import { render, staticRenderFns } from "./detailPrescription.vue?vue&type=template&id=1366fe2a&scoped=true"
import script from "./detailPrescription.vue?vue&type=script&lang=js"
export * from "./detailPrescription.vue?vue&type=script&lang=js"
import style0 from "./detailPrescription.vue?vue&type=style&index=0&id=1366fe2a&prod&scoped=true&lang=css"
import style1 from "./detailPrescription.vue?vue&type=style&index=1&id=1366fe2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1366fe2a",
  null
  
)

export default component.exports